import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiVisualstudio,
  DiReact,
  DiHtml5,
  DiPython,
  DiGit,
  DiAndroid,
  DiMsqlServer,
  DiDotnet,
  DiCss3,
  DiPhotoshop  
} from "react-icons/di";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
       <Col xs={4} md={2} className="tech-icons">
        <DiHtml5 />
      </Col>
       <Col xs={4} md={2} className="tech-icons">
        <DiCss3 />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiDotnet />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiVisualstudio />
      </Col>     
      <Col xs={4} md={2} className="tech-icons">
        <DiReact />
      </Col>     
      <Col xs={4} md={2} className="tech-icons">
        <DiPython />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiMsqlServer />
      </Col>     
      <Col xs={4} md={2} className="tech-icons">
        <DiGit />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiAndroid />
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <DiPhotoshop />
      </Col>
    </Row>
  );
}

export default Techstack;
